import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: { //数据源
    token: '',
    isLogin: false,
    // chatUrl:"http://cjr.cn/api.php/OAuth/wxLogin"
  },
  // 获取属性的状态
  getters: {
    //获取登录状态
    isLogin: state => state.isLogin,
  },
  mutations: { //修改值
    SET_TOKEN(state, token) {
      state.token = token
      state.isLogin = true
    }
  },
  actions: {
    setToken({
      commit
    }, token) {
      commit('SET_TOKEN', token);
      localStorage.setItem("tokenId", token);
      localStorage.setItem("Flag", "isLogin");
    }
  }
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js